export default __webpack_public_path__ + "static/media/BG-DarkBlue-0001.5fd93e19.png";